import React from "react";
import "./ServicesNew.css";
import { Container, Row, Col } from "react-bootstrap";

// Import icons from react-icons
import { FaYoutube, FaMusic, FaUserTie, FaShieldAlt, FaPaintBrush, FaShareAlt } from "react-icons/fa";

const services = [
  {
    title: "Channel Management",
    description:
      "VDNI fully understands the nitty-gritty of managing a channel on various platforms. Many of our clients who are content creators benefit from our expertise.",
    icon: <FaYoutube />,
  },
  {
    title: "Audio Streaming",
    description:
      "Music streaming has been a daunting task, and we at VDNI fully understand the technical nuances required to make it seamless.",
    icon: <FaMusic />,
  },
  {
    title: "Celebrity Management",
    description:
      "VDNI has the expertise to manage celebrity accounts with respect to their profiles across the digital platforms.",
    icon: <FaUserTie />,
  },
  {
    title: "Copyright Protection / DMCA",
    description:
      "Protecting rights owners from piracy by limiting distribution of unlicensed content on all video sharing platforms. VDNI ensures your copyrights are protected on partner platforms.",
    icon: <FaShieldAlt />,
  },
  {
    title: "Graphics & Logo Designing",
    description:
      "Transform your brand's identity with our creative Graphics & Logo Designing services. Craft a visual masterpiece that captivates and leaves a lasting impression.",
    icon: <FaPaintBrush />,
  },
  {
    title: "Social Media Management",
    description:
      "Elevate your online presence and engagement with our strategic social media management services, building connections that matter and driving brand success.",
    icon: <FaShareAlt />,
  },
];

const ServicesNew = () => {
  return (
    <div className="services-section">
      <Container>
        <Row className="text-center mb-5">
          <h2>
            Our <span>Services</span>
          </h2>
          <p className="services-intro">
            Explore the wide range of solutions VDNI offers to boost your brand and digital presence.
          </p>
        </Row>
        <Row>
          {services.map((service, index) => (
            <Col key={index} md={6} lg={4} className="mb-4">
              <div className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h4 className="service-title">{service.title}</h4>
                <p className="service-description">{service.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default ServicesNew;
